
export const plantDetails = {
  main_heading: "NEURER PLANET",
  sub_heading: "Geben Sie hier einen Untertitel an",
  sub_heading_dark: " Geben Sie detailliertere infos zu ihrem planeten an",
  description:
    "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
  button_lable: "Speichern",
  name_lable: "Planet",
  sub_lable: "Slogan",
  des_lable: "Beschreibung",
  status_lable: "Status",
  address_lable: "Adresse",
  sub_name_lable: "Kontakt",
  email_lable: "E-Mail",
  nr_lable: "Telefon",
  planent_heading: "Planeten auswahlen",
  land_heading: "Oberflache auswahlen",
  building_heading: "Hauptobjekt wahlen",
};


export const statusOption = [
  { lable: "Concept_Stage", id: 3 },
  { lable: "Building_stage", id: 2 },
  { lable: "Growth_Stage", id: 1 },
  { lable: "live", id: 0 },
];


export const planetManageConfig = {
  title: 'create_planet',
  sub_title: 'provide_more_detailed_information_about_your_planet',
  planetInputConfig: [
    {
      name: "pro_name",
      type: "text",
      placeholder: "planet_name",
      label: "planet_name",
      style: "col-6",
      fieldType: 'input'
    },
    {
      name: "pro_sub",
      type: "text",
      placeholder: "planet_sub_name",
      label: "planet_sub_name",
      style: "col-6",
      fieldType: 'input'
    },
    {
      name: "pro_address",
      type: "text",
      placeholder: "address",
      label: "address",
      style: "col-6",
      fieldType: 'input'
    }
  ],
  planetContactInputConfig: [
    {
      name: "pro_contact_name",
      type: "text",
      placeholder: "contact_name",
      label: `contact_name`,
      style: `col-6 `,
      fieldType: 'input'
    },
    {
      name: "pro_status_id",
      type: "text",
      placeholder: "status",
      label: "status",
      style: "col-6 ",
      fieldType: 'dropDown',
    },
    {
      name: "pro_contact_email",
      type: "text",
      placeholder: "contact_email",
      label: "contact_email",
      style: "col-6",
      fieldType: 'input'
    },
    {
      name: "pro_contact_phone",
      type: "number",
      placeholder: "contact_phone",
      label: "contact_phone",
      style: "col-6",
      fieldType: 'input'
    },
    {
      name: "pro_desc",
      type: "text",
      placeholder: "planet_desc",
      label: "planet_desc",
      style: "col-12",
      fieldType: 'textEditor'
    },
  ],
  btnConfig:{
    icon:'save',
    label:'save'
  }


}




